import React from 'react'

const navigator  = require('web-midi-api');

export default class MidiController extends React.Component{

    componentDidMount () {
        navigator.requestMIDIAccess().then(this.onMIDISuccess, this.onMIDIFailure);
    }

    componentWillUnmount = () =>{
        navigator.close();
    }

    onMIDIFailure = (msg) =>{
        console.log('Host page Failed to get MIDI access - ' + msg);
    }

    onMidiIn = (ev) =>  {
        if (ev.data[0] === 144 && ev.data[1] === 32) {
                this.props.handleBetClick()
        }
        if (ev.data[0] === 144 && ev.data[1] === 24){
             this.props.handleAskClick()
        } 
        if (ev.data[0] === 144 && ev.data[1] === 29){ //TODO
                this.props.onDownloadChampions
        }
    }   

    onMIDISuccess = (midiAccess) =>{
        midiAccess.inputs.forEach(port => {
          port.onmidimessage = this.onMidiIn;
        });
    }
    render() {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/components/MidiController.js